"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signSecp256k1Message = exports.generateSighashAll = exports.signSecp256k1SessionTx = exports.calcEthPersonalHash = exports.signSecp256k1Tx = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const utils_1 = require("../utils");
const constants_1 = require("../constants");
const js_sha3_1 = require("js-sha3");
// personal hash, ethereum prefix  \u0019Ethereum Signed Message:\n32
const PERSONAL_SIGN_ETH_PREFIX = [
    0x19, 0x45, 0x74, 0x68, 0x65, 0x72, 0x65, 0x75, 0x6d, 0x20, 0x53, 0x69, 0x67, 0x6e, 0x65, 0x64,
    0x20, 0x4d, 0x65, 0x73, 0x73, 0x61, 0x67, 0x65, 0x3a, 0x0a, 0x33, 0x32,
];
const signSecp256k1Tx = (key, transaction, mode = constants_1.WITNESS_NATIVE_MODE) => {
    if (!key)
        throw new Error('Private key or address object');
    const witnessGroup = transaction.witnesses;
    if (!witnessGroup.length) {
        throw new Error('WitnessGroup cannot be empty');
    }
    if (typeof witnessGroup[0] !== 'object') {
        throw new Error('The first witness in the group should be type of WitnessArgs');
    }
    const transactionHash = (0, ckb_sdk_utils_1.rawTransactionToHash)(transaction);
    const emptyWitness = Object.assign(Object.assign({}, witnessGroup[0]), { lock: `0x${'0'.repeat(constants_1.SECP256K1_PUBKEY_SIG_LEN)}` });
    const serializedEmptyWitnessBytes = (0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.serializeWitnessArgs)(emptyWitness));
    const serializedEmptyWitnessSize = serializedEmptyWitnessBytes.length;
    const hasher = js_sha3_1.keccak_256.create();
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)(transactionHash));
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${serializedEmptyWitnessSize.toString(16)}`)));
    hasher.update(serializedEmptyWitnessBytes);
    witnessGroup.slice(1).forEach(w => {
        const bytes = (0, ckb_sdk_utils_1.hexToBytes)(typeof w === 'string' ? w : (0, ckb_sdk_utils_1.serializeWitnessArgs)(w));
        hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${bytes.length.toString(16)}`)));
        hasher.update(bytes);
    });
    const sighash = hasher.array();
    const message = (0, exports.calcEthPersonalHash)(sighash);
    // console.log("hash", ethers.utils.hashMessage(sighash))
    const pubkeyHash = (0, utils_1.getSecp256k1PubkeyHash)(key);
    const signature = (0, exports.signSecp256k1Message)(key, message);
    emptyWitness.lock = `0x${mode}${pubkeyHash}${signature}`;
    const signedWitnesses = [(0, ckb_sdk_utils_1.serializeWitnessArgs)(emptyWitness), ...witnessGroup.slice(1)];
    return Object.assign(Object.assign({}, transaction), { witnesses: signedWitnesses.map(witness => (typeof witness === 'string' ? witness : (0, ckb_sdk_utils_1.serializeWitnessArgs)(witness))) });
};
exports.signSecp256k1Tx = signSecp256k1Tx;
const calcEthPersonalHash = (sighash) => {
    const keccaker = js_sha3_1.keccak_256.create();
    keccaker.update(PERSONAL_SIGN_ETH_PREFIX);
    keccaker.update(sighash);
    return `0x${keccaker.hex()}`;
};
exports.calcEthPersonalHash = calcEthPersonalHash;
const signSecp256k1SessionTx = (key, sessionKey, transaction, mode = constants_1.WITNESS_NATIVE_SESSION_MODE) => {
    if (!key)
        throw new Error('Private key or address object');
    const witnessGroup = transaction.witnesses;
    if (!witnessGroup.length) {
        throw new Error('WitnessGroup cannot be empty');
    }
    if (typeof witnessGroup[0] !== 'object') {
        throw new Error('The first witness in the group should be type of WitnessArgs');
    }
    const transactionHash = (0, ckb_sdk_utils_1.rawTransactionToHash)(transaction);
    const emptyWitness = Object.assign(Object.assign({}, witnessGroup[0]), { lock: '0x' });
    const serializedEmptyWitnessBytes = (0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.serializeWitnessArgs)(emptyWitness));
    const serializedEmptyWitnessSize = serializedEmptyWitnessBytes.length;
    let hasher = (0, ckb_sdk_utils_1.blake2b)(32, null, null, ckb_sdk_utils_1.PERSONAL);
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)(transactionHash));
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${serializedEmptyWitnessSize.toString(16)}`)));
    hasher.update(serializedEmptyWitnessBytes);
    witnessGroup.slice(1).forEach(w => {
        const bytes = (0, ckb_sdk_utils_1.hexToBytes)(typeof w === 'string' ? w : (0, ckb_sdk_utils_1.serializeWitnessArgs)(w));
        hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${bytes.length.toString(16)}`)));
        hasher.update(bytes);
    });
    const message = `0x${hasher.digest('hex')}`;
    if (sessionKey.getKeySize() !== 2048) {
        throw new Error('RSA key size error');
    }
    const signature = (0, utils_1.signRSAMessage)(sessionKey, message);
    // Build sessoin message and attestation with secp256r1
    const sessionVer = '00';
    const sessionPubkey = (0, utils_1.exportPubKey)(sessionKey);
    const sessionMessage = (0, utils_1.blake256)(`0x${sessionVer}${sessionPubkey}`);
    const keccaker = js_sha3_1.keccak_256.create();
    keccaker.update(PERSONAL_SIGN_ETH_PREFIX);
    keccaker.update((0, ckb_sdk_utils_1.hexToBytes)(`0x${sessionMessage}`));
    const attestationMessage = `0x${keccaker.hex()}`;
    const pubkeyHash = (0, utils_1.getSecp256k1PubkeyHash)(key);
    const attestation = (0, exports.signSecp256k1Message)(key, attestationMessage);
    emptyWitness.lock = `0x${mode}${sessionPubkey}${signature}${pubkeyHash}${sessionVer}${attestation}`;
    const signedWitnesses = [(0, ckb_sdk_utils_1.serializeWitnessArgs)(emptyWitness), ...witnessGroup.slice(1)];
    return Object.assign(Object.assign({}, transaction), { witnesses: signedWitnesses.map(witness => (typeof witness === 'string' ? witness : (0, ckb_sdk_utils_1.serializeWitnessArgs)(witness))) });
};
exports.signSecp256k1SessionTx = signSecp256k1SessionTx;
const generateSighashAll = (transaction) => {
    const witnessGroup = transaction.witnesses;
    if (!witnessGroup.length) {
        throw new Error('WitnessGroup cannot be empty');
    }
    if (typeof witnessGroup[0] !== 'object') {
        throw new Error('The first witness in the group should be type of WitnessArgs');
    }
    const transactionHash = (0, ckb_sdk_utils_1.rawTransactionToHash)(transaction);
    const emptyWitness = Object.assign(Object.assign({}, witnessGroup[0]), { lock: `0x${'0'.repeat(constants_1.SECP256K1_PUBKEY_SIG_LEN)}` });
    const serializedEmptyWitnessBytes = (0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.serializeWitnessArgs)(emptyWitness));
    const serializedEmptyWitnessSize = serializedEmptyWitnessBytes.length;
    const hasher = js_sha3_1.keccak_256.create();
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)(transactionHash));
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${serializedEmptyWitnessSize.toString(16)}`)));
    hasher.update(serializedEmptyWitnessBytes);
    witnessGroup.slice(1).forEach(w => {
        const bytes = (0, ckb_sdk_utils_1.hexToBytes)(typeof w === 'string' ? w : (0, ckb_sdk_utils_1.serializeWitnessArgs)(w));
        hasher.update((0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.toUint64Le)(`0x${bytes.length.toString(16)}`)));
        hasher.update(bytes);
    });
    return hasher.hex();
};
exports.generateSighashAll = generateSighashAll;
const signSecp256k1Message = (key, message) => {
    const msg = (0, ckb_sdk_utils_1.hexToBytes)(message);
    const { r, s, recoveryParam } = key.sign(msg, {
        canonical: true,
    });
    // console.log('secp256k1 signature verify result: ', key.verify(msg, { r, s, recoveryParam }))
    const fmtR = r.toString(16).padStart(64, '0');
    const fmtS = s.toString(16).padStart(64, '0');
    return `${fmtR}${fmtS}0${recoveryParam}`;
};
exports.signSecp256k1Message = signSecp256k1Message;
